export default __webpack_public_path__ + "static/media/castle2.db70008c.jpg";